import {ProcessElementProps} from "./ProcessElementProps";

export class ProcessEdgeProps extends ProcessElementProps {
	constructor(processEditor, fieldPath, obj, member) {
		super(processEditor, fieldPath, obj, member);
	}
}